// src/lib/dxfParse.js
// ============================================================================
// Parser DXF mínimo del lado CLIENTE — SOLO para previsualizar la FORMA REAL del
// 1UP / la imposición en el cotizador (no calcula precio: eso es server-side en
// functions/lib/dielines.js). Port de `parseDxf` + bbox (LINE + ARC → polilíneas
// con color). PURO, sin deps. Cut = color 1 (rojo), crease = color 2 (amarillo).
// ============================================================================

// Parse DXF (LINE + ARC) → polilíneas { color, pts:[[x,y],...] }.
export function parseDxf(text) {
  const L = String(text || '').split(/\r?\n/).map((s) => s.trim());
  const pairs = [];
  for (let i = 0; i + 1 < L.length; i += 2) {
    const code = parseInt(L[i], 10);
    if (Number.isNaN(code)) { i -= 1; continue; }
    pairs.push([code, L[i + 1]]);
  }
  const ents = [];
  let cur = null;
  for (const [c, v] of pairs) {
    if (c === 0) { if (cur) ents.push(cur); cur = { type: v }; }
    else if (cur) (cur[c] = cur[c] || []).push(v);
  }
  if (cur) ents.push(cur);

  const numv = (e, k) => (e[k] ? parseFloat(e[k][0]) : undefined);
  const polys = [];
  for (const e of ents) {
    const color = e[62] ? parseInt(e[62][0], 10) : 0;
    if (e.type === 'LINE') {
      polys.push({ color, pts: [[numv(e, 10), numv(e, 20)], [numv(e, 11), numv(e, 21)]] });
    } else if (e.type === 'ARC') {
      const cx = numv(e, 10); const cy = numv(e, 20); const r = numv(e, 40);
      const a0 = numv(e, 50); const a1 = numv(e, 51); const sweep = ((a1 - a0) % 360 + 360) % 360;
      const pts = []; const n = 24;
      for (let k = 0; k <= n; k++) {
        const a = (a0 + sweep * k / n) * Math.PI / 180;
        pts.push([cx + r * Math.cos(a), cy + r * Math.sin(a)]);
      }
      polys.push({ color, pts });
    }
  }
  return polys;
}

// Bounding box de un conjunto de polilíneas.
export function bbox(polys) {
  let minx = Infinity; let miny = Infinity; let maxx = -Infinity; let maxy = -Infinity;
  for (const { pts } of polys || []) {
    for (const [x, y] of pts) {
      if (x < minx) minx = x; if (x > maxx) maxx = x;
      if (y < miny) miny = y; if (y > maxy) maxy = y;
    }
  }
  if (!isFinite(minx)) return { x: 0, y: 0, minx: 0, miny: 0 };
  return { x: maxx - minx, y: maxy - miny, minx, miny };
}

// Polilínea → atributo `points` de un <polyline> SVG, con offset y volteo vertical
// (DXF tiene Y hacia arriba; SVG hacia abajo) sobre la altura `h`.
export function toPoints(pts, ox = 0, oy = 0, h = 0) {
  return pts.map(([x, y]) => `${(x + ox).toFixed(3)},${(h - (y + oy)).toFixed(3)}`).join(' ');
}
